module.exports = __webpack_public_path__ + "static/media/stars3.c2a86e06.svg";